import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddAmenity from "./components/addAmenity";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { respEnum } from "../../constants/appConstant";

const Amenities = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open]);

  const getData = async () => {
    setLoading(true);
    const response = await Common.ApiService.getInstance().request(
      "GetMasterAmenities"
    );
    if (response?.data) {
      setData(response?.data);
      setLoading(false);
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Amenity?",
      "Delete Amenity"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteMasterAmenity?id=${id}`,
        {},
        "Delete"
      );

      if (resp.message) {
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getData(1);
        }, 500);
      }
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Amenity Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    {
      title: "Status",
      type: "text",
      isVisible: true,
      key: "isactive",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            row.isactive
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {row.isactive ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <AdvanceTable
        title={"Amenities"}
        columns={_thead.filter((item) => item.isVisible)}
        data={{ data: data }}
        getData={getData}
        addButton={() => (
          <AddAmenity
            id={refId}
            onClose={() => getData()}
            open={open}
            setOpen={setOpen}
          />
        )}
        showPagination={false}
        showAddButton
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
      />
    </>
  );
};

export default Amenities;
